import React from 'react';
const SelectNativeOption = ({ id, value, disabled, children, onClick, label, testId, ...others }) => {
    return (React.createElement("option", { id: id, value: value, disabled: disabled, "aria-label": label, "data-testid": testId, ...others, onClick: (e) => {
            onClick && onClick(e);
        } }, children || label));
};
export default SelectNativeOption;
//# sourceMappingURL=SelectNativeOption.js.map